import WorkstationAvailability, {
  GetTemplateWorkstationAvailabilitiesPayload,
} from "app/models/workstationAvailability"

export enum Types {
  GET = "TEMPLATE_WORKSTATIONS_AVAILABILITIES_GET",
  GET_SUCCESS = "TEMPLATE_WORKSTATIONS_AVAILABILITIES_GET_SUCCESS",
  GET_FAIL = "TEMPLATE_WORKSTATIONS_AVAILABILITIES_GET_FAIL",
}

export type Action =
  | GetTemplateWorkstationAvailabilitiesAction
  | GetTemplateWorkstationAvailabilitiesSuccessAction
  | GetTemplateWorkstationAvailabilitiesFailAction

export type GetTemplateWorkstationAvailabilitiesAction = {
  payload: GetTemplateWorkstationAvailabilitiesPayload
  type: Types.GET
}

export type GetTemplateWorkstationAvailabilitiesSuccessAction = {
  payload: { data: WorkstationAvailability[] }
  type: Types.GET_SUCCESS
}

export type GetTemplateWorkstationAvailabilitiesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export function getTemplateWorkstationAvailabilities(
  payload: GetTemplateWorkstationAvailabilitiesPayload,
): GetTemplateWorkstationAvailabilitiesAction {
  return {
    payload,
    type: Types.GET,
  }
}

export function getTemplateWorkstationAvailabilitiesSuccess(
  data: WorkstationAvailability[],
): GetTemplateWorkstationAvailabilitiesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getTemplateWorkstationAvailabilitiesFail(
  errors: object,
): GetTemplateWorkstationAvailabilitiesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
